// TSS vite/04 §"Endpoint paths".
// No leading slash — axios joins baseURL + url with a single slash.

export const tierPaths = {
    list:   ()   => 'admin/tiers',
    detail: (id) => `admin/tiers/${id}`,
    // Which tiers this one waits for. Its own screen when the graph gets one.
    dependencies: (id) => `admin/tiers/${id}/dependencies`,
};
